import React, { useRef } from 'react';
import { FaCode, FaMobileAlt, FaDollarSign, FaGraduationCap, FaFacebook, FaTwitter, FaGithub, FaInstagram } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';
import "../Css/Experience.css";

export default function Experience() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_d5d9gjs', 'template_7rbb78k', form.current, {
      publicKey: 'NNfkLo0zoAZ75x1Jo',
    }).then(
      () => {
        Swal.fire({
          icon: 'success',
          title: 'Message Sent!',
          text: 'I\'ll get back to you soon.',
          confirmButtonColor: 'greenyellow'
        });
        form.current.reset();
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong! Please try again.',
          confirmButtonColor: 'greenyellow'
        });
        console.log('FAILED...', error.text);
      }
    );
  };
  const experiences = [
    {
      title: "Junior Software Developer",
      company: "Thrivewave Solutions",
      location: "Nairobi, Kenya (Remote)",
      period: "June 2025 – Present",
      description: [
        "Contribute to the design, development, testing, and deployment of production web platforms used by business clients.",
        "Build responsive and user-friendly interfaces using Vue.js.",
        "Integrate frontend applications with backend APIs and services.",
        "Collaborate with backend, product, and design teams to deliver production-ready features.",
        "Participate in code reviews, debugging, and performance optimization.",
        "Use Git for collaborative development and version control."
      ],
      icon: <FaCode className="exp-icon" />
    },
    {
      title: "Mobile Developer Intern",
      company: "SiafuSocial",
      location: "Nairobi, Kenya (Remote)",
      period: "Jan 2025 – Feb 2025",
      description: [
        "Developed and maintained mobile applications using React Native, TypeScript, and Expo.",
        "Identified and resolved bugs to improve application performance and stability.",
        "Collaborated with designers and backend developers to implement mobile features.",
        "Conducted testing across multiple devices to ensure reliable performance.",
        "Assisted in mobile application architecture and optimization."
      ],
      icon: <FaMobileAlt className="exp-icon" />
    },
    {
      title: "Software Development Intern",
      company: "Cellulant Kenya Limited",
      location: "Kenya",
      period: "May 2022 – Aug 2022",
      description: [
        "Supported development and integration of payment APIs for financial systems.",
        "Assisted in troubleshooting payment processing issues.",
        "Worked with cross-functional teams to improve operational workflows.",
        "Gained hands-on experience in fintech systems and API integration."
      ],
      icon: <FaCode className="exp-icon" />
    },
    {
      title: "Sales and General Manager",
      company: "Victorian Egg Depot",
      location: "Kenya",
      period: "Jan 2019 – Apr 2022",
      description: [
        "Managed daily business operations including procurement, distribution, and sales.",
        "Developed strategies to improve revenue and customer relationships.",
        "Supervised sales staff and monitored performance.",
        "Managed budgeting, bookkeeping, and financial tracking.",
        "Streamlined operational processes and improved service delivery."
      ],
      icon: <FaDollarSign className="exp-icon" />
    }
  ];

  const education = [
    {
      title: "Certificate in Software Engineering",
      company: "Moringa School",
      location: "",
      period: "Sept 2023 – Feb 2024",
      description: [
        "Intensive training in full-stack web development using React, Flask, Node.js, JavaScript, and Python.",
        "Built practical projects using modern frameworks and tools."
      ],
      icon: <FaGraduationCap className="exp-icon" />
    },
    {
      title: "Bachelor of Science in Business Information Technology",
      company: "Meru University of Science and Technology",
      location: "",
      period: "July 2019 – Oct 2023",
      description: [
        "Courses included software development, cybersecurity, and business strategy, equipping me with the necessary skills to develop tech solutions for business challenges.",
        "Studied software development, cybersecurity, data management, and business strategy.",
        "Developed knowledge of technology solutions for business operations."
      ],
      icon: <FaGraduationCap className="exp-icon" />
    }
  ];

  const renderSection = (title, items, icon) => (
    <div className="experience-section">
      <div className="section-header">
        <h2 className='sectionTitle'>{title}</h2>
      </div>
      <div className='experience-timeline'>
        {items.map((item, index) => (
          <div className='experience-card' key={index}>
            <div className="exp-icon-container">
              {item.icon}
              {index < items.length - 1 && <div className="timeline-connector"></div>}
            </div>
            <div className="exp-content">
              <h3>{item.title}</h3>
              <div className="exp-meta">
                {item.company && <span className="exp-company">{item.company}</span>}
                {item.location && <span className="exp-location">{item.location}</span>}
                {item.period && <span className="exp-period">{item.period}</span>}
              </div>
              <ul className="exp-description">
                {item.description.map((desc, i) => (
                  <li key={i}>{desc}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  
  return (
    <section id='experience'>
      <div className="experience-header">
        <h2 className='experienceTitle'>Professional Experience</h2>
        <p className='experienceDesc'>
          Results-driven Full-Stack Software Developer with experience delivering production-ready web applications, 
          collaborating with cross-functional teams, and optimizing application performance.
        </p>
      </div>

      {renderSection("Work Experience", experiences)}

      {renderSection("Education", education)}

      <div id='contact'>
        <div className="contact-header">
          <h2 className='contactTitle'>Let's Connect</h2>
          <p className='contactDesc'>
            Have a project in mind or want to discuss opportunities? Reach out — I'm always open to interesting conversations.
          </p>
          <div className="contact-info">
            <p>📞 +254 703 387 133</p>
            <p>✉️ murithivictor791@gmail.com</p>
            <p>🌐 LinkedIn | Portfolio | GitHub</p>
          </div>
        </div>
        
        <form ref={form} className='contact-form' onSubmit={sendEmail}>
          <div className="form-group">
            <input 
              type='text' 
              placeholder='Your Name' 
              name='your_name' 
              className='form-input' 
              required 
            />
          </div>
          <div className="form-group">
            <input 
              type='email' 
              placeholder='Your Email' 
              className='form-input' 
              name='your_email' 
              required 
            />
          </div>
          <div className="form-group">
            <textarea 
              name='message' 
              placeholder='Your Message' 
              className='form-textarea' 
              rows='5' 
              required
            />
          </div>
          <button className='contact-btn' type='submit'>
            Send Message
          </button>
          
          <div className='social-links'>
            <button type="button" aria-label="Facebook" className="social-link"><FaFacebook /></button>
            <button type="button" aria-label="Instagram" className="social-link"><FaInstagram /></button>
            <button type="button" aria-label="Twitter" className="social-link"><FaTwitter /></button>
            <button type="button" aria-label="GitHub" className="social-link"><FaGithub /></button>
          </div>
        </form>
      </div>
    </section>
  );
}